import ShopItem from './shop-item'
export default ShopItem;